<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <g>
        <path
          d="M13.9994,4L2,3.98639L2.00115,3L14.0006,3.01361L13.9994,4ZM2.80058,10.78176C2.47096,11.02896,2.000580013,10.793759999999999,2.000580013,10.38176L2.000580013,5.631740000000001C2.000580013,5.21971,2.47096,4.98452,2.80058,5.23174L5.96724,7.60674C6.23391,7.80674,6.23391,8.20674,5.96724,8.40674L2.80058,10.78176ZM7.50058,7.51367L14,7.51367L14,8.513670000000001L7.50058,8.513670000000001L7.50058,7.51367ZM13.9994,13L2,12.98639L2.00115,12L14.0006,12.01361L13.9994,13Z"
          fill="currentColor"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
